import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

function EditFabricModal({ show, onHide, fabric, onSave, saving }) {
  const [nameInput, setNameInput] = useState("");
  const [priceInput, setPriceInput] = useState("0");
  const [originPriceInput, setOriginPriceInput] = useState("0");
  const [imageFile, setImageFile] = useState();
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    if (!show) {
      return;
    }
    setNameInput(fabric?.name || "");
    setPriceInput(String(fabric?.price ?? 0));
    setOriginPriceInput(String(fabric?.originPrice ?? 0));
    setImageFile(undefined);
    setImagePreview(fabric?.imageSrc || "");
  }, [show, fabric]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>ແກ້ໄຂປະເພດຜ້າ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>ອັບໂຫລດຮູບຜ້າ</Form.Label>
          <Form.Control
            id="edit-fabric-file-upload"
            type="file"
            accept="image/*"
            multiple={false}
            hidden
            onChange={(e) => {
              const file = e.target.files?.[0];
              setImageFile(file);
              setImagePreview(file ? URL.createObjectURL(file) : "");
            }}
          />
          <label htmlFor="edit-fabric-file-upload" style={{ margin: 0, width: "100%" }}>
            <div
              style={{
                backgroundColor: "#F9FAFB",
                height: 250,
                width: "100%",
                border: "1px dashed #93989F",
                borderRadius: 8,
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {imagePreview ? (
                <img src={imagePreview} alt="edit-fabric-preview" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />
              ) : (
                <>
                  <CloudUploadOutlinedIcon sx={{ fontSize: 36, color: "#93989F" }} />
                  <p style={{ color: "#93989F", marginTop: 8, marginBottom: 4 }}>ເພີ່ມຮູບຜ້າ</p>
                  <p style={{ color: "#3C169B", textDecoration: "underline", marginBottom: 0 }}>Browse</p>
                </>
              )}
            </div>
          </label>
          <p style={{ color: "#93989F", marginTop: 8, marginBottom: 0 }}>ກົດຮູບອີກເທື່ອ ເພື່ອປ່ຽນຮູບ</p>
        </Form.Group>
        <div className="mt-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Form.Group>
            <Form.Label>ລາຄາຂາຍ</Form.Label>
            <Form.Control type="number" min={0} value={priceInput} onChange={(e) => setPriceInput(e.target.value)} placeholder="0" />
          </Form.Group>
          <Form.Group>
            <Form.Label>ລາຄາຕົ້ນທຶນ</Form.Label>
            <Form.Control type="number" min={0} value={originPriceInput} onChange={(e) => setOriginPriceInput(e.target.value)} placeholder="0" />
          </Form.Group>
        </div>
        <Form.Group className="mt-3">
          <Form.Label>ຊື່ປະເພດຜ້າ</Form.Label>
          <Form.Control value={nameInput} onChange={(e) => setNameInput(e.target.value)} placeholder="ປ້ອນຊື່ຜ້າ" />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          ຍົກເລີກ
        </Button>
        <Button
          variant="primary"
          disabled={saving}
          onClick={() =>
            onSave({
              id: fabric?.id,
              name: nameInput.trim(),
              price: Number(priceInput || 0),
              originPrice: Number(originPriceInput || 0),
              imageFile,
            })
          }
        >
          ບັນທຶກ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditFabricModal;
